/**
 * @module platformPlusFeatures
 */

export default {
  deviceTrust: {
    name: 'Device Trust',
    description: 'establishes a connection with JumpCloud managed devices that can grant or deny access based on the status of the device.',
  },
  networkTrust: {
    name: 'Network Trust',
    description: 'can be utilized by specifing public IP ranges and determining how users’ authentication is affected by the network they’re coming from.',
  },
};
